import styled from 'styled-components';
import ProfileSection from './ProfileSection';
import MenuSection from './MenuSection';
import { useNavigate } from 'react-router-dom';
import { Button } from 'basic-ui-lib';
import { useAppDispatch } from 'store/hooks';
import authActions from 'modules/auth/services/actions';
import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
// import { FooterMobileSetting } from 'layouts/widgets/Footer/FooterMobileSetting';
// import { Button } from '@khahama/pmk-foods-ui';

const SettingPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const confirmModalRef = useModalConfirmRef();

  useEffect(() => {
    if (isDesktop) {
      navigate('/screen');
    }
  }, [isDesktop]);

  const handleLogout = () => {
    dispatch(authActions.logout.fetch());
  };

  const handleLogoutConfirm = () => {
    confirmModalRef.current?.open(handleLogout, {
      message: 'Are you sure you want to log out?',
      okText: 'Sign Out',
    });
  };

  return (
    <Container>
      <ProfileSection />
      <MenuSection />
      <Button type='button' type_cancel onClick={handleLogoutConfirm} lg>
        Sign Out
      </Button>
      <ModalConfirm ref={confirmModalRef} />
    </Container>
  );
};
export default SettingPage;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px 32px;
`;
